import React, { useState } from 'react';
import {
  useNavigate
} from "react-router-dom";
import axios from 'axios';
import SftGlobalData from '../library/SftGlobalData';
import Android from '@mui/icons-material/Android';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import Switch from '@mui/material/Switch';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import consultationLogo from '../assets/mobile-icons/ic_consultation.png'
import inventoryLogo from '../assets/mobile-icons/ic_inventory.png'
import inventoryInvertedLogo from '../assets/mobile-icons/ic_inventory_inverted.png'
import deliveryLogo from '../assets/mobile-icons/ic_delivery.png'
import giftLogo from '../assets/mobile-icons/ic_gift.png'
import pickingLogo from '../assets/mobile-icons/ic_picking.png'
import returnLogo from '../assets/mobile-icons/ic_return.png'
import stockposLogo from '../assets/mobile-icons/ic_stockpos.png'
import transferRequestLogo from '../assets/mobile-icons/ic_transfer_request.png'
import transferLogo from '../assets/mobile-icons/ic_transfer.png'
import settingLogo from '../assets/mobile-icons/ic_settings.png'
import catalogLogo from '../assets/mobile-icons/ic_catalog.png'
import webshopLogo from '../assets/mobile-icons/ic_webshop.png'
import customerLogo from '../assets/mobile-icons/ic_customer.png'
import stockCorrLogo from '../assets/mobile-icons/ic_correction.png'
import stockCorrInvertedLogo from '../assets/mobile-icons/ic_correction_inverted.png'
import manSaleLogo from '../assets/mobile-icons/ic_manual_sale.png'
import consignmentLogo from '../assets/mobile-icons/ic_consignment.png'
import packlistLogo from '../assets/mobile-icons/ic_packlist.png'
import labelLogo from '../assets/mobile-icons/ic_label_print.png'
import cloudPrintLogo from '../assets/mobile-icons/ic_cloud_print.png'
import salesLogo from '../assets/mobile-icons/ic_mod_sales.png'
import scanLogo from '../assets/mobile-icons/ic_scan.png';
import Colors from '../library/Colors';

const ModuleCard = (props) => {
    const [checkedState, setCheckedState] = useState(parseInt(props.checked) === 1 ? true : false);
    let navigate = useNavigate();
  
    const submitHandler = async (value) => {
        let postData = {
            key: props.api,
            module: props.setting,
            value: value ? "1" : "0"
        };
        if(props.groupId !== '0000'){
          postData.groupId = props.groupId;
        }

        SftGlobalData.post('mobileSettings&action=editModules', postData).then(response => {

        });
      }

  

    let modIcon = inventoryLogo;
    //console.log("setting", props.setting);
    switch(props.setting){
        case 'Consultation':
            modIcon = consultationLogo;
            break;
        case 'Inventory':
            if(props.theme === 'dark'){
                modIcon = inventoryInvertedLogo;
            } else {
                modIcon = inventoryLogo;
            }
            break;
        case 'Transfer':
            modIcon = transferLogo;
            break;
        case 'StockPositions':
            modIcon = stockposLogo;
            break;
        case 'TransferRequest':
            modIcon = transferRequestLogo;
            break;
        case 'Picking':
            modIcon = pickingLogo;
            break;
        case 'Giftlist':
            modIcon = giftLogo;
            break;
        case 'Return':
            modIcon = returnLogo;
            break;
        case 'Delivery':
            modIcon = deliveryLogo;
            break;
        case 'StockCorrection':
            if(props.theme === 'dark'){
                modIcon = stockCorrInvertedLogo;
            } else {
                modIcon = stockCorrLogo;
            }
            break;
        case 'ManualSale':
            modIcon = manSaleLogo;
            break;
        case 'Manualsale':
            modIcon = manSaleLogo;
            break;
        case 'Consignment':
            modIcon = consignmentLogo;
            break;
        case 'Catalog':
            modIcon = catalogLogo;
            break;
        case 'Packlist':
            modIcon = packlistLogo;
            break;
        case 'Webshop':
            modIcon = webshopLogo;
            break;
        case 'Customer':
            modIcon = customerLogo;
            break;
        case 'Label':
            modIcon = labelLogo;
            break;
        case 'Uploads':
            modIcon = cloudPrintLogo;
            break;
        case 'Sales':
            modIcon = salesLogo;
            break;
        case 'ScanModule':
            modIcon = scanLogo;
            break;
        default:
            modIcon = settingLogo;
            break;
    }

    const androidMods = ["Inventory", "Transfer", "StockPositions", "Picking", "Giftlist", "Return", "Delivery", "StockCorrection", "ManualSale", "Consignment", "Packlist", "Sales"];

    const isDark = props.theme === 'dark';
    const clickable = !props.noClick;
    const showSwitch = !props.hideSwitch && props.title !== "General" && props.title !== "Label";

    const handleNavigate = () => {
        if(!props.noClick){
            // navigateTo: absolute in-app path override (e.g. the Uploads card
            // targets mobile/uploads instead of a module settings page).
            if(props.navigateTo){
                navigate("/"+props.lang+"/"+props.navigateTo);
            } else if(props?.groupId === "0000")
                navigate("/"+props.lang+"/module/"+props.setting);
            else
                navigate("/"+props.lang+"/module/"+props.setting+"/"+props.groupId);
        }
    };

    const cardContent = (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', flexGrow: 1, p: 1.5 }}>
            <img src={modIcon} alt={props.title} width="64" height="64" />
            <Typography sx={{ mt: 1, fontWeight: 600, fontSize: 14, textAlign: 'center', lineHeight: 1.25 }}>
                {props.title}
            </Typography>
        </Box>
    );

    return (
        <Card
            className={props.className}
            elevation={isDark ? 0 : 2}
            sx={{
                position: 'relative',
                width: 172,
                height: 172,
                m: 0.75,
                borderRadius: '20px',
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: isDark ? Colors.dark_accent : Colors.light_accent,
                color: isDark ? Colors.dark_text : Colors.light_text,
                border: isDark ? `1px solid ${Colors.dark_accent_darker}` : 'none',
                transition: 'transform 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease',
                '&:hover': {
                    backgroundColor: isDark ? Colors.dark_accent_darkest : Colors.light_accent_darker,
                    transform: clickable ? 'translateY(-2px)' : 'none',
                    boxShadow: isDark ? 'none' : 6,
                },
            }}
        >
            {(androidMods.indexOf(props.setting) > -1) &&
                <Android sx={{ position: 'absolute', top: 8, left: 8, color: Colors.def_green, fontSize: 22, zIndex: 1 }} />}

            {clickable ? (
                <CardActionArea onClick={handleNavigate} sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                    {cardContent}
                </CardActionArea>
            ) : cardContent}

            <Box sx={{ height: 42, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {showSwitch &&
                    <Switch
                        checked={checkedState}
                        onChange={() => { submitHandler(!checkedState); setCheckedState(!checkedState); }}
                        sx={{
                            '& .MuiSwitch-switchBase.Mui-checked': { color: Colors.sft_blue },
                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: Colors.sft_blue },
                        }}
                    />}
            </Box>
        </Card>
    );
}

export default ModuleCard;
